module.exports = __webpack_public_path__ + "static/media/megagres.9a5194c4.svg";